(function() {
'use strict';
  
  angular.module('app.viewSync', [
    
  ]);
  
})();